import {combineReducers} from 'redux'
import pageinate from './paginate'
import {actionTypes} from '../actions/search'
import {getInitialFromQuery, requestTypes} from '../utils'

const initialState = {
  currentPage: Number(getInitialFromQuery('page')) || 1,
  resultsPerPage: 25,
  error: false,
  totalHits: 0,
  totalPage: 0,
  query: getInitialFromQuery('q') || '',
  navQuery: '', // This needs its own reducer when developed further
}

const pages = pageinate({
  mapActionToKey: action => String(action.payload.page),
  types: [
    actionTypes.FETCH_SEARCH[requestTypes.REQUEST],
    actionTypes.FETCH_SEARCH[requestTypes.SUCCESS],
    actionTypes.FETCH_SEARCH[requestTypes.FAILURE],
    actionTypes.UPDATE_SEARCH_QUERY, // Set updateSearchQuery as clear type to flush data.
  ],
})

const status = (state = initialState, {type, payload}) => {
  switch(type) {
    case actionTypes.UPDATE_SEARCH_QUERY:
      return {...state, currentPage: 1, query: payload}
    case actionTypes.UPDATE_NAV_SEARCH_QUERY:
      return {...state, navQuery: payload}
    case actionTypes.FETCH_SEARCH[requestTypes.REQUEST]:
      return {...state, error: false}
    case actionTypes.FETCH_SEARCH[requestTypes.SUCCESS]:
      const {totalHits, totalPage} = payload
      return {
        ...state, error: false, totalHits, totalPage,
      }
    case actionTypes.FETCH_SEARCH[requestTypes.FAILURE]:
      return {...state, error: payload.error}
    case actionTypes.CHANGE_PAGE:
      return {...state, currentPage: payload}
    default:
      return state
  }
}

export default combineReducers({
  status,
  pages,
})



// WEBPACK FOOTER //
// ./src/store/reducers/search.js